module.exports = __webpack_public_path__ + "img/fo.037e466d.svg";